import { render, staticRenderFns } from "./itemMatome.vue?vue&type=template&id=36f9ae97&"
import script from "./itemMatome.vue?vue&type=script&lang=js&"
export * from "./itemMatome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports